/* eslint-disable no-fallthrough */
import { getToken, returnError } from './helperFunc';
import { getReviewsAction, resolveReviewAction,sendReplyAction, getNotificationsAction, markNotificationAsReadAction, markAllNotificationsAsReadAction } from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_REVIEW_LOADING = 'SET_REVIEW_LOADING';
const CLEAR_REVIEW_ERROR = 'CLEAR_REVIEW_ERROR';

const RESOLVE_REVIEW_SUCCESS = 'RESOLVE_REVIEW_SUCCESS';
const RESOLVE_REVIEW_FAIL = 'RESOLVE_REVIEW_FAIL';

const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS';
const GET_REVIEWS_FAIL = 'GET_REVIEWS_FAIL';

const SEND_REPLY_SUCCESS = 'SEND_REPLY_SUCCESS';
const SEND_REPLY_FAIL = 'SEND_REPLY_FAIL';

const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
const GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL';

const MARK_NOTIFICATION_READ_SUCCESS = 'MARK_NOTIFICATION_READ_SUCCESS';
const MARK_NOTIFICATION_READ_FAIL = 'MARK_NOTIFICATION_READ_FAIL';

const MARK_ALL_NOTIFICATIONS_READ_SUCCESS = 'MARK_ALL_NOTIFICATIONS_READ_SUCCESS';
const MARK_ALL_NOTIFICATIONS_READ_FAIL = 'MARK_ALL_NOTIFICATIONS_READ_FAIL';

// FOR OUTLETS

export const getReviews = (query) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await getReviewsAction(query, token);

    dispatch({ type: GET_REVIEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_REVIEWS_FAIL, payload: returnError(error) });
  }
};

export const resolveReview = (reqBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await resolveReviewAction(reqBody, token);

    dispatch({ type: RESOLVE_REVIEW_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: RESOLVE_REVIEW_FAIL, payload: returnError(error) });
  }
};

export const sendReply = (reqBody) => async (dispatch, getState) => {
  try {
    // console.log('Sending reply with data:', reqBody);
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await sendReplyAction(reqBody, token);

    dispatch({ type: SEND_REPLY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SEND_REPLY_FAIL, payload: returnError(error) });
  }
};

export const fetchNotifications = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    const token = getToken(user);

    const response = await getNotificationsAction(token);
    const notifications = response.data.data;

    dispatch({ type: GET_NOTIFICATIONS_SUCCESS, payload: notifications });
  } catch (error) {
    dispatch({ type: GET_NOTIFICATIONS_FAIL, payload: returnError(error) });
  }
};

export const markNotificationAsRead = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    const token = getToken(user);

    await markNotificationAsReadAction(id, token);

    dispatch({ type: MARK_NOTIFICATION_READ_SUCCESS, payload: { id } });
  } catch (error) {
    dispatch({ type: MARK_NOTIFICATION_READ_FAIL, payload: returnError(error) });
  }
};

export const markAllNotificationsAsRead = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_REVIEW_LOADING });
    dispatch({ type: CLEAR_REVIEW_ERROR });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await markAllNotificationsAsReadAction(token);

    dispatch({ type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MARK_ALL_NOTIFICATIONS_READ_FAIL, payload: returnError(error) });
  }
};

const initialState = {
  language: 'en',
  error: null,
  loading: false,
  reviews: [],
  review: null,
  replyStatus: null,
  notifications: [],
};

export const reviewDashReducer = function (state = initialState, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_REVIEW_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_REVIEW_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
      };

    case GET_REVIEWS_SUCCESS:
      // console.log("action.payload", action.payload);
      return {
        ...state,
        reviews: action.payload,
        loading: false,
        error: null,
      };
    case RESOLVE_REVIEW_SUCCESS:
      return {
        ...state,
        review: action.payload.data,
        error: null,
      };

    case SEND_REPLY_SUCCESS:
      return {
        ...state,
        replyStatus: 'success',
        loading: false,
        error: null,
      };

      case GET_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          notifications: action.payload, 
          unreadCount: action.payload.length,
          loading: false,
        };
      case GET_NOTIFICATIONS_FAIL:
        
      case MARK_NOTIFICATION_READ_SUCCESS:
        return {
          ...state,
          notifications: state.notifications.map((notif) =>
            notif.id === action.payload.id ? { ...notif, read: true } : notif
          ),
          loading: false,
          error: null,
        };
  
      case MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
        return {
          ...state,
          notifications: state.notifications.map((notif) => ({ ...notif, read: true })),
          loading: false,
          error: null,
        };
  
      case MARK_NOTIFICATION_READ_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case MARK_ALL_NOTIFICATIONS_READ_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

    case SEND_REPLY_FAIL:
      return {
        ...state,
        replyStatus: 'fail',
        loading: false,
        error: action.payload,
      };

    case LOGOUT_SUCCESS:
      return initialState;

    case GET_REVIEWS_FAIL:
    case RESOLVE_REVIEW_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
